import { LineStyle } from '../../renderers/draw-line';
import { SimpleLineOptions, ExtendedType } from '../../model/simple-line-options';
import { UTCTimestamp } from 'lightweight-charts';

export const simpleLineOptionsDefaults: SimpleLineOptions = {
	color: '#FF0000',
	lineStyle: LineStyle.Dashed,
	lineWidth: 1,
	extended: ExtendedType.NoExtended,
	data: [{
		time: 0.0 as UTCTimestamp,
		value: 0.0,
	},{
		time: 1.0 as UTCTimestamp,
		value: 0.0,
	},],	
};
